<template>
  <div>
    <pop-in
      :text="textProjectOpposition" @close-modal="$emit('close-modal')"
      @validation="$emit('validation'); $emit('close-modal')"
    />
  </div>
</template>

<script>
import PopIn from "@/components/PopIn";

export default {
  name: 'PopInProjectOpposition',
  components: {PopIn},
  data() {
    return {
      textProjectOpposition: {},};
  },

  created() {
    this.map = this.projectOpposition;
    this.textProjectOpposition.content = "En application de l’article 56 de la Loi Informatique et Libertés, vous allez" +
        " vous opposer à ce que des données à caractère personnel vous concernant ou concernant la personne pour " +
        "laquelle vous agissez en tant que représentant légal fassent l'objet de traitements automatisés ayant pour " +
        "finalité la recherche. Ceci ne changera en rien en rien la qualité des soins qui seront prodigués à vous ou " +
        "la personne pour laquelle vous agissez en tant que représentant légal. " +
        "Pour révoquer cette opposition, vous devrez contacter l’établissement de santé par mail";

    this.textProjectOpposition.confirmMessage = " Voulez vous confirmer ce choix ?";
    this.textProjectOpposition.validation = "Confirmer mon opposition";
  }
};
</script>